<button type="button" (click)="onClick($event)" class="btn btn-info save-btn">{{label}}</button>